import { Phone, MapPin, Leaf } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "@/data/site";

const QUICK = NAV_LINKS.filter((l) => ["Products", "Services", "About Us", "Contact"].includes(l.label));

export default function Footer() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="footer" className="relative bg-[#111a11] pt-20 pb-10 text-white/80">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--green)] text-white"><Leaf size={20} /></span>
              <span className="font-display text-2xl font-bold text-white">M N Savanur</span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-white/60">
              Wholesale vegetable & spice merchants supplying premium quality produce in bulk across Karnataka.
            </p>
          </div>

          <div>
            <h4 className="overline text-[var(--gold)]">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {QUICK.map((l) => (
                <li key={l.href}>
                  <button data-testid={`footer-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`} onClick={() => go(l.href)} className="text-sm text-white/70 transition-colors hover:text-[var(--gold)]">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="overline text-[var(--gold)]">Contact</h4>
            <a href={`tel:${BUSINESS.phone}`} className="mt-5 flex items-center gap-2 text-sm text-white/70 hover:text-white">
              <Phone size={15} /> {BUSINESS.phone}
            </a>
          </div>

          <div>
            <h4 className="overline text-[var(--gold)]">Address</h4>
            <p className="mt-5 flex gap-2 text-sm leading-relaxed text-white/70">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>{BUSINESS.addressLines.join(" ")}</span>
            </p>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-6 text-center text-xs text-white/50">
          © 2026 M N Savanur. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
